import React from 'react'

const Login = () => {
  return (
    <div>
        <h1>Login solo publico</h1>
    </div>
  )
}

export default Login